import React from 'react'

import {
    MdLocalOffer,
    MdStayCurrentPortrait,
    MdAssignmentInd,
    MdWifi,
    MdMap
} from "react-icons/md";
import { GoGraph, GoSettings } from "react-icons/go";
import { BsGrid3X3Gap } from "react-icons/bs";
import { CgUserList } from "react-icons/cg";
import { RiFilePaper2Line } from "react-icons/ri";


export const structureSuper = [
    {
        id: 0,
        label: "Gateways",
        link: "/gateway",
        icon: <MdWifi/>,
    },
    {
        id: 2,
        label: "Clientes",
        icon: <MdAssignmentInd/>,
        link: "/clientes",
    },
    {
        id: 4,
        label: "Legales",
        icon: <RiFilePaper2Line/>,
        link: "/legales-superadmin",
    },
    
    {
        id: 7,
        label: "Nodos",
        icon: <MdStayCurrentPortrait/>,
        link: "/nodos"
    },
    
    {
        id: 15,
        label: "Marcas",
        icon: <MdLocalOffer/>,
        link: "/marcas",
    },
    {
        id: 10,
        label: "Localidades",
        icon: <MdMap/>,
        link: "/localidades"
    },    
    {
        id: 752,
        label: "Service-profiles",
        icon: <CgUserList />,
        link: "/serviceProfiles"
    },
    {
        id: 11,
        label: "Device-profiles",
        icon: <GoSettings/>,
        link: "/deviceProfiles"
    },
    {
        id: 98,
        label: "Applications",
        icon: <BsGrid3X3Gap/>,
        link: "/applications"
    },
    {
        id: 789,
        label: "Estadisticas",
        icon: <GoGraph />,
        link: "/estadisticasresumen" // before -> "/estadisticas"
    }
];